import { Close } from '@mui/icons-material';
import {
	Box,
	Checkbox,
	Dialog,
	Divider,
	FormControlLabel,
	FormGroup,
	Grid,
	IconButton,
	Stack,
} from '@mui/material';
import Dimens from 'assets/dimens';
import {
	Captcha, DefaultButton, DefaultInput, SizedBox, TitleSmall,
} from 'common/presentation/components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useHome from '../provider/home.provider';

interface Props {
	open: boolean
	handleClose: () => void
}

const RecommendModal: FC<Props> = (props) => {
	const { open, handleClose } = props;
	const { t } = useTranslation('translations');
	const {
		submitRecommendReq,
		recommendLoading,
		recommendValues,
		setRecommendValues,
		recommendErrors,
		setCaptcha,
		redrawCaptcha,
	} = useHome();

	const getCaptcha = (mCaptcha: string) => {
		setCaptcha(mCaptcha);
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		setRecommendValues({ ...recommendValues, [name]: value });
	};

	const handleFormSubmit = async () => {
		const res = await submitRecommendReq();
		if (res) {
			handleClose();
		}
	};

	return (
		<Dialog open={open} onClose={handleClose}>
			<Box sx={{ p: Dimens.FOOTER_PADDING_BOTTOM_MOBILE }}>
				<Stack direction="row" justifyContent="space-between">
					<TitleSmall>{t('recommend')}</TitleSmall>
					<IconButton onClick={handleClose}>
						<Close />
					</IconButton>
				</Stack>
				<Divider />
				<>
					<Grid container spacing={3}>
						<Grid item md={12} xs={12}>
							<DefaultInput
								name="name"
								value={recommendValues.name}
								error={!!recommendErrors.name}
								helperText={recommendErrors.name}
								disabled={recommendLoading}
								onChange={handleChange}
								title={t('your_full_name')}
								placeholder={t('your_full_name')}
							/>
						</Grid>
					</Grid>
					<Divider sx={{ my: 2 }} />
					<TitleSmall
						sx={{
							fontSize: { md: Dimens.TEXT_MEDIUM, xs: Dimens.TEXT_MEDIUM_SMALL },
							lineHeight: { md: Dimens.TEXT_MEDIUM, xs: Dimens.TEXT_MEDIUM_SMALL },
							mt: 2,
						}}
					>
						{t('supplier_info')}
					</TitleSmall>
					<Grid container spacing={3}>
						<Grid item md={12} xs={12}>
							<DefaultInput
								name="supplierName"
								value={recommendValues.supplierName}
								error={!!recommendErrors.supplierName}
								helperText={recommendErrors.supplierName}
								disabled={recommendLoading}
								onChange={handleChange}
								title={t('name')}
								placeholder={t('enter_supplier_name')}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={3}>
						<Grid item md={6} xs={12}>
							<DefaultInput
								name="supplierEmail"
								value={recommendValues.supplierEmail}
								error={!!recommendErrors.supplierEmail}
								helperText={recommendErrors.supplierEmail}
								disabled={recommendLoading}
								onChange={handleChange}
								title={t('email')}
								placeholder={t('enter_supplier_email')}
							/>
						</Grid>
						<Grid item md={6} xs={12}>
							<DefaultInput
								name="supplierPhone"
								value={recommendValues.supplierPhone}
								error={!!recommendErrors.supplierPhone}
								helperText={recommendErrors.supplierPhone}
								disabled={recommendLoading}
								onChange={handleChange}
								title={t('phone')}
								placeholder={t('enter_supplier_phone')}
							/>
						</Grid>
					</Grid>
					<Divider sx={{ mt: 2 }} />
					<Grid container spacing={3}>
						<Grid item md={12} xs={12}>
							<DefaultInput
								name="note"
								value={recommendValues.note}
								onChange={handleChange}
								title={t('message')}
								placeholder={t('message_info')}
								rows={5}
								multiline
							/>
						</Grid>
					</Grid>
					<Grid container spacing={3}>
						<Grid item md={12} xs={12}>
							<SizedBox height={2} />
							<Captcha
								width={300}
								height={150}
								getCaptcha={getCaptcha}
								redrawCaptcha={redrawCaptcha}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={3}>
						<Grid item md={12} xs={12}>
							<DefaultInput
								name="captcha"
								error={!!recommendErrors.captcha}
								helperText={recommendErrors.captcha}
								value={recommendValues.captcha}
								disabled={recommendLoading}
								onChange={handleChange}
								title={t('verification_code')}
								placeholder={t('write_verification_code')}
							/>
							<FormGroup>
								<FormControlLabel control={<Checkbox defaultChecked />} label={t('accept_collection_of_info')} />
							</FormGroup>
							<DefaultButton loading={recommendLoading} onClick={handleFormSubmit} size="small">{t('submit_request')}</DefaultButton>
						</Grid>
					</Grid>
				</>
			</Box>
		</Dialog>
	);
};

export default RecommendModal;
